// @ts-nocheck

import * as Types from '../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type UpdateCustomFieldDefinitionMutationVariables = Types.Exact<{
  customFieldDefinition: Types.CustomFieldDefinitionModelInput;
}>;

export type UpdateCustomFieldDefinitionMutation = { updateCustomFieldDefinition: { uid: string } };

export const UpdateCustomFieldDefinitionDocument = gql`
    mutation UpdateCustomFieldDefinition($customFieldDefinition: CustomFieldDefinitionModelInput!) {
  updateCustomFieldDefinition(customFieldDefinition: $customFieldDefinition) {
    uid
  }
}
    ` as unknown as DocumentNode<UpdateCustomFieldDefinitionMutation, UpdateCustomFieldDefinitionMutationVariables>;
